export const IndexedDBConfig = {
    name: "blocks-code-db",
    version: 1,
    storeName: "files",
    storeConfig: { keyPath: "id", autoIncrement: false },
};
